import { useState } from 'react';
import { Send, Linkedin, Github } from 'lucide-react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

// EmailJS keys from Clip Web V1
const SERVICE_ID = "service_1ta1w2p";
const TEMPLATE_ID = "template_dolju9a";
const PUBLIC_KEY = "dD2ULLQlQ2LnBMEmA";

export function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({ firstName: '', lastName: '', email: '', phone: '', subject: '', message: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const templateParams = {
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      phone: formData.phone || 'Non renseigné',
      subject: formData.subject || 'Pas de sujet',
      message: formData.message
    };

    try {
      const response = await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
      console.log('✅ Email envoyé avec succès:', response);

      Swal.fire({
        title: "Merci !",
        text: "Votre message a été envoyé avec succès. Je vous répondrai dans les plus brefs délais.",
        icon: "success",
        confirmButtonColor: "#000000",
        confirmButtonText: "SUPER !"
      });
      resetForm();
    } catch (error) {
      console.error('❌ Erreur EmailJS:', error);
      Swal.fire({
        title: "Erreur",
        text: "Impossible d'envoyer le message. Veuillez réessayer ou me contacter à clipweb.info@gmail.com",
        icon: "error",
        confirmButtonColor: "#000000"
      });
    } finally {
      setIsLoading(false);
    }
  };

  const inputClass = "w-full p-4 border-4 border-black font-bold text-lg focus:outline-none focus:ring-4 focus:ring-cyan-400 bg-white";

  return (
    <section id="contact" className="bg-white py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-yellow-300 border-4 border-black p-12 shadow-[20px_20px_0px_0px_rgba(0,0,0,1)] relative mt-16 md:mt-0">
          <div className="absolute top-[-28px] -left-2 md:-top-6 md:-left-6 bg-orange-600 text-white px-4 md:px-6 py-3 font-black text-xl md:text-2xl border-4 border-black rotate-[-5deg] shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] whitespace-nowrap">
            VOUS ÊTES INTÉRESSÉ ?
          </div>

          <h2 className="text-4xl md:text-5xl font-black mb-8 mt-2 md:mt-4">
            PARLONS DE VOTRE PROJET
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block font-black text-lg mb-2">PRÉNOM *</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="Jean"
                />
              </div>
              <div>
                <label className="block font-black text-lg mb-2">NOM *</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="Dupont"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block font-black text-lg mb-2">EMAIL *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="jean.dupont@email.com"
                />
              </div>
              <div>
                <label className="block font-black text-lg mb-2">TÉLÉPHONE</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className={inputClass}
                  placeholder="06 12 34 56 78"
                />
              </div>
            </div>

            <div>
              <label className="block font-black text-lg mb-2">OBJET *</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Création d'un site web"
              />
            </div>

            <div>
              <label className="block font-black text-lg mb-2">MESSAGE *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={6}
                className={`${inputClass} resize-none`}
                placeholder="Décrivez votre projet en quelques lignes..."
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-black text-white px-8 py-6 font-black text-2xl border-4 border-black shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1.5 hover:translate-y-1.5 transition-all flex items-center justify-center gap-4 group disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] disabled:hover:translate-x-0 disabled:hover:translate-y-0"
            >
              {isLoading ? 'ENVOI EN COURS...' : 'ENVOYER'}
              {!isLoading && (
                <Send className="w-8 h-8 group-hover:translate-x-2 group-hover:-translate-y-1 transition-transform" />
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="bg-black text-white py-12 px-6 border-t-4 border-black">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h3 className="text-3xl font-black mb-4">CLIP WEB</h3>
            <p className="text-lg font-bold">Développement Web & Design Graphique</p>
          </div>

          <div className="flex gap-6">
            <a
              href="https://www.linkedin.com/in/leo-langlois/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-cyan-400 text-black p-4 border-4 border-white hover:bg-yellow-400 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-8 h-8" />
            </a>
            <a
              href="https://github.com/LeoLgls"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-violet-600 text-white p-4 border-4 border-white hover:bg-orange-600 transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-8 h-8" />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t-4 border-white text-center">
          <p className="font-bold text-lg">
            © {new Date().getFullYear()} Léo Langlois - CLIP Web - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
}
